<div class="merchant-picker">
  <!-- TRIGGER BUTTON -->
  <button class="picker-trigger"
    [attr.data-test]="'merchant-picker-button'"
    [disabled]="allBuids().length === 0"
    [class.is-open]="dropdownActive"
    (click)="ToggleDropdown()">
    <mat-icon class="outline picker-trigger-icon mon-text-white">location_on</mat-icon>
    @if (selectedBuid() === undefined) {
      <div class="picker-trigger-label">
        <span class="picker-trigger-name mon-text-white">{{ allBuids().length > 0 ? 'Select a location' : 'No locations' }}</span>
      </div>
    } @else {
      <div class="picker-trigger-label">
        <span class="picker-trigger-name mon-text-white">{{ selectedBuid()?.name }}</span>
        @if (showMids && selectedMid()) {
          <span class="picker-trigger-mid mon-text-white">{{ selectedMid()?.monekId }}</span>
        }
      </div>
    }
    <mat-icon class="picker-trigger-chevron mon-text-white">{{ dropdownActive ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>

  <!-- BACKDROP -->
  @if (dropdownActive) {
    <div class="picker-backdrop" (click)="ToggleDropdown()"></div>
  }

  <!-- DROPDOWN PANEL -->
  @if (dropdownActive) {
    <div class="picker-dropdown main-panel"
         [class.drop-up]="dropUp" [class.drop-down]="!dropUp"
         [class.fullscreen]="fullscreen">

      <!-- HEADER -->
      <div class="picker-header">
        <div class="picker-header-title">
          <mat-icon class="outline picker-header-icon">location_on</mat-icon>
          <h6 class="my-0">Locations</h6>
        </div>
        <button class="picker-close-btn" (click)="ToggleDropdown()" data-test="app-merchant-picker-toggle-dropdown-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- SEARCH -->
      @if (allBuids().length >= 3) {
        <div class="picker-search">
          <mat-icon class="picker-search-icon">search</mat-icon>
          <input type="text" class="picker-search-input"
                 placeholder="Search locations..."
                 [ngModel]="filter" (ngModelChange)="onFilterChange($event)" maxlength="50" />
        </div>
      }

      <!-- LOCATION LIST -->
      <div class="picker-list">
        @if (hasMultipleOrganisations() && filteredBuids.length > 0) {
          <div class="picker-org-header"
               [attr.data-test]="'merchant-org-' + activeOrganisationId">
            <mat-icon class="outline picker-org-icon">business</mat-icon>
            <span class="picker-org-name">{{ activeOrganisationName() }}</span>
          </div>
        }
        @for (merchant of filteredBuids; track merchant.id; let last = $last) {
          <div class="picker-item"
               [class.picker-item--selected]="selectedBuid()?.id === merchant.id"
               [class.picker-item--last]="last">

            <!-- Location row -->
            <div class="picker-item-row">
              <button class="picker-item-btn"
                      [attr.data-test]="'merchant-buid-' + merchant.id"
                      [attr.data-test-name]="'merchant-buid-' + merchant.name"
                      (click)="SelectMerchant(merchant)">
                <mat-icon class="outline picker-item-icon"
                          [class.mon-text-primary]="selectedBuid()?.id === merchant.id">
                  {{ selectedBuid()?.id === merchant.id ? 'check_circle' : 'storefront' }}
                </mat-icon>
                <span class="picker-item-name">{{ merchant.name }}</span>
              </button>

              <button class="picker-fav-btn" (click)="FavouriteToggle(merchant)" data-test="app-merchant-picker-favourite-toggle-button">
                @if (merchant.favouriteLoading) {
                  <div class="picker-fav-spinner">
                    <div class="spinner-grow spinner-grow-sm" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                } @else {
                  <mat-icon class="picker-fav-icon"
                            [class.is-favourite]="merchant.favourite">
                    {{ merchant.favourite ? 'star' : 'star_border' }}
                  </mat-icon>
                }
              </button>
            </div>

            <!-- MIDs sub-section -->
            @if (showMids && selectedBuid()?.id === merchant.id && MerchantAvailableMidCount(merchant) > 0) {
              <div class="picker-mids">
                <div class="picker-mids-list">
                  @for (mid of merchant.mids; track mid.monekId) {
                    <button class="picker-mid-chip"
                            [class.picker-mid-chip--active]="selectedMid()?.monekId === mid.monekId"
                            (click)="SelectMerchantMid(mid); ToggleDropdown()"
                            [attr.data-test]="'merchant-mid-' + mid.monekId"
                            [matTooltip]="mid.acquirer.length > 8 ? mid.acquirer : ''"
                            matTooltipPosition="above"
                            matTooltipClass="picker-mid-tooltip"
                            matTooltipShowDelay="1000">
                      {{ mid.monekId }}
                      @if (mid.acquirer.length > 0) {
                        <span class="picker-mid-chip-acquirer">{{ mid.acquirer.length > 8 ? (mid.acquirer | slice:0:8) + '…' : mid.acquirer }}</span>
                      }
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }

        @if (hasMultipleOrganisations()) {
          @for (org of filteredOtherOrgs; track org.organisationId) {
            <button class="picker-org-header picker-org-header--other"
                    [attr.data-test]="'merchant-org-' + org.organisationId"
                    [disabled]="switchingOrgId() !== null"
                    (click)="SelectOtherOrgBuid(org)">
              <mat-icon class="outline picker-org-icon">business</mat-icon>
              <span class="picker-org-name">{{ org.organisationName }}</span>
              @if (switchingOrgId() === org.organisationId) {
                <div class="picker-org-spinner">
                  <div class="spinner-grow spinner-grow-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              }
            </button>
            @for (bu of org.businessUnits; track bu.buid) {
              <div class="picker-item">
                <div class="picker-item-row">
                  <button class="picker-item-btn"
                          [attr.data-test]="'merchant-org-buid-' + bu.buid"
                          [attr.data-test-name]="'merchant-org-buid-' + bu.name"
                          [disabled]="switchingOrgId() !== null"
                          (click)="SelectOtherOrgBuid(org, bu)">
                    <mat-icon class="outline picker-item-icon">storefront</mat-icon>
                    <span class="picker-item-name">{{ bu.name }}</span>
                  </button>
                </div>
              </div>
            }
          }
        }
      </div>

      <!-- SHOW ALL (fixed footer, toggles full-screen view) -->
      <button class="picker-showall-btn" (click)="ToggleFullscreen()" data-test="app-merchant-picker-show-all-button">
        <mat-icon class="picker-showall-icon">{{ fullscreen ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
        {{ fullscreen ? 'Exit full screen' : 'Show all' }}
      </button>

      <!-- PARTNER SWITCH -->
      @if (userIsPartner()) {
        <button class="picker-switch-btn" (click)="switchOrganisation()" data-test="app-merchant-picker-switch-organisation-button">
          <mat-icon class="picker-switch-icon">swap_horiz</mat-icon>
          Switch Organisation
        </button>
      }
    </div>
  }
</div>
